import { Component, OnInit, forwardRef, ViewChild, ChangeDetectorRef } from '@angular/core';
import { MatTabGroup } from '@angular/material/tabs'
import { AppConfigurationService } from '../../core/services/AppConfigurationService';
import { TileContainer } from '../../pillar/dashboard/services/TileContainer';
import { RouteHistorySubTab } from '../../pillar/layout/route-history-sub-tab';
import { RouteHistoryService } from '../../pillar/layout/route-history.service';
import { CurrentUserService } from '../../security/services/CurrentUserService';

@Component({
  selector: 'brd-administration-dashboard',
  providers: [{ provide: TileContainer, useExisting: forwardRef(() => AdministrationDashboardComponent) }],
  templateUrl: './administration-dashboard.component.html',
  styleUrls: ['./administration-dashboard.component.scss']
})
export class AdministrationDashboardComponent extends TileContainer implements OnInit {
  static dashboardName = 'administration';
  currentTab: string = null;
  manageSubmittingEntities: boolean = true;

  viewUsersPermission: string = 'CustomerModule.Users:View';
  viewMessagesPermission: string = 'ConfigurationModule.Messages:View';
  viewRolesPermission: string = 'SecurityModule.Roles:View';
  viewGroupsPermission: string = 'CustomerModule.Groups:View';
  viewSupportTicketPermission: string = 'ConfigurationModule.SupportTicket:View';

  @ViewChild('tabGroup')
  tabGroup: MatTabGroup;

  get name(): string {
    return AdministrationDashboardComponent.dashboardName;
  }

  get tab(): string {
    return this.currentTab;
  }

  constructor(private changeDetectorRef: ChangeDetectorRef,
    public historyService: RouteHistoryService,
    private currentUserService: CurrentUserService,
    private appConfigurationService: AppConfigurationService) {
      super();
      this.manageSubmittingEntities = !appConfigurationService.configuration.isDelegatingSubmittingEntityManagementToOtherSystem;
  }

  tabClick(event: any) {
    this.currentTab = event.tab.textLabel;
    var currTab = new RouteHistorySubTab(this.name, event.tab.textLabel, event.index);
    this.historyService.setLastSubTab(currTab);
  }

  ngAfterViewInit() {
    if(this.historyService.lastSubTab && this.historyService.lastSubTab.moduleName == this.name){
      this.currentTab = this.historyService.lastSubTab.tabName;
      this.tabGroup.selectedIndex = this.historyService.lastSubTab.tabIndex;
    } else {
      this.currentTab = this.tabGroup._tabs.first.textLabel;
    }
    this.changeDetectorRef.detectChanges();
  }

  ngOnInit() {
  }

  hasPermission (permission: string) {
    return this.currentUserService.hasPermission(permission);
  }
}



// WEBPACK FOOTER //
// ./src/app/administration/components/administration-dashboard.component.ts